// @flow

import Decimal from 'decimal.js';

import { getBottlesFromQty } from './getBottlesFromQty';
import { getCasesFromQty } from './getCasesFromQty';

const getCombinedCasesAndBottlesInBottles = (Qty: number, Uom: number) => {
  return Decimal.add(getCasesFromQty(Qty) * Uom, getBottlesFromQty(Qty, Uom))
    .toDecimalPlaces(5, 1)
    .toNumber();
};

export { getCombinedCasesAndBottlesInBottles };
